
































































import { PurchaseHistory, RideCreditProfile } from '@/types/entity';
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '../../components/DataTable.vue';
// tslint:disable-next-line:no-var-requires
const RideCreditActivitytatable = require('../../datatable/RideCreditActivityLog.json');
// tslint:disable-next-line:no-var-requires
const RideCreditUsageDatatable = require('../../datatable/CreditUsageTable.json');

@Component({
    data() {
        return {
            imagePreview: '',
        };
    },
    components: {
        DataTable,
    },
    props: {
        rideCreditProfile: {
            type: Object,
            required: true,
        },
    },
})
export default class ViewRideCreditModal extends Vue {

    private show = true;
    private rideCreditActivityDataSource = RideCreditActivitytatable;

    private mounted() {
        this.rideCreditActivityDataSource.data = [];
        this.rideCreditActivityDataSource.data = [];
        const profileDetails: RideCreditProfile = this.$props.rideCreditProfile;
        if (profileDetails.rideCreditActivity) {
            this.rideCreditActivityDataSource.data = profileDetails.rideCreditActivity.logs;
        }
    }

    private close() {
        this.$emit('close');
    }

}
